import { useState } from "react";
import clsx from "clsx";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from "../shared/dropdown";
import { SharedIcon } from "../shared/shared-icon";

export const ACTIVITY_FEED_FILTERS = {
  following: "following",
  allMembers: "allMembers",
};

export const DEFAULT_ACTIVITY_FEED_FILTER = ACTIVITY_FEED_FILTERS.allMembers;

export function ActivityFeedFilter({ label, title, options, value, onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const selectedOption = options.find((option) => option.value === value);

  return (
    <div className="activity-feed-filter">
      {Boolean(title) && <p className="activity-feed-filter__title">{title}</p>}
      <div className="activity-feed-filter__controls">
        {label && <span className="activity-feed-filter__label">{label}</span>}
        <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
          <DropdownMenuTrigger className="activity-feed-filter__trigger">
            {selectedOption?.label}
            <SharedIcon
              iconName="#sprite-icon-dropdown-arrow"
              className={clsx("activity-feed-filter__trigger-icon", {
                "activity-feed-filter__trigger-icon--open": isOpen,
              })}
            />
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="activity-feed-filter__content"
            align="start"
            side="bottom"
            sideOffset={4}
          >
            <DropdownMenuRadioGroup value={value} onValueChange={onChange}>
              {options.map((option) => (
                <DropdownMenuRadioItem
                  key={option.value}
                  value={option.value}
                  className="activity-feed-filter__item"
                >
                  {option.label}
                </DropdownMenuRadioItem>
              ))}
            </DropdownMenuRadioGroup>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
}
